import React, { useEffect, useState } from 'react';
import AgendaStreamingContextProvider from '../common/AgendaStreamingContextProvider';
import LiveContext from '../contexts/LiveContext';
import { MAX_COLUMNS } from '../data/constants';
// import { SeoContext } from '../data/seo/SeoContextProvider';
import { initStatsUtils } from '../data/sport-utils';
import { initTables } from '../tables-utils';
import Calendar from './calendar/Calendar';
import LiveSuite from './live-suite/LiveSuite';
import LiveMatch from './match/LiveMatch';
import MultiBet from './multi-bet/MultiBet';
import MultiLive from './multi-live/MultiLive';
import { isLiveTrackerEnabled } from '../data/utils';

export const CustomCols = React.createContext(null);

function Live(props) {
    const liveContext = React.useContext(LiveContext);
    // const seoContext = React.useContext(SeoContext);

    let firstMatch = null;
    const [context, setContext] = useState({
        data : liveContext.data,
        matchData : liveContext.matchData,
        matchDataPalAvv: liveContext.matchDataPalAvv,
        currentMatch: firstMatch,
        showFavourites: false,
        update(updt) {
            setContext(prev => {
                return {...prev, ...updt};
            });
        },
        setData: function(data) {
           liveContext.setData(data);
           this.update({data});
        },
        setMatchData: function(matchData) {
           liveContext.setMatchData(matchData);
        },
        setMatchDataPalAvv: function(matchDataPalAvv) {
            liveContext.setMatchDataPalAvv(matchDataPalAvv);
         },
        changeMatch: function(sportId, countryId, tournamentId, matchId) {
            const currentMatch = this.getMatch(sportId, countryId, tournamentId, matchId);
            this.update({currentMatch});
        },
        resetMatch: function() {
            this.update({currentMatch: null});
        },
        openMatch: function(sport, country, tournament, match) {
            context.changeMatch(sport, country, tournament, match);
            window.openSection('live-match');
        },
        getMatch: function(sportId, countryId, tournamentId, matchId) {
            try {
                if (arguments.length === 0) {
                    const firstSport = this.data.sport[0]; 
                    const firstCountry = firstSport.categories[0]; 
                    const firstTournament = firstCountry.tournaments[0]; 
                    const firstMatch = firstTournament.events[0]; 
                    sportId = firstSport.id;
                    countryId = firstCountry.id;
                    tournamentId = firstTournament.id;
                    matchId = firstMatch.id;
                }
                // Se si cambio match dai preferiti passando da uno sport ad un altro, la mappa country by id � vuota e quindi non parte la chiamata
                const match = liveContext.data.sportById[sportId].categoryById[countryId].tournamentById[tournamentId].matchById[matchId];
                return match;
            } catch(err) {
                return null;
            }
        }
    });

    if (liveContext.matchData != null) {
        const md = liveContext.matchData;
        context.openMatch(md.sportId, md.countryId, md.tournamentId, md.matchId);
        context.setMatchData(null);
    }

    if (liveContext.data && liveContext.matchData == null && liveContext.matchDataPalAvv) {
        const match = liveContext.data?.matches?.find(m=> {return m.pal == liveContext.matchDataPalAvv.pal && m.avv == liveContext.matchDataPalAvv.avv});
        context.changeMatch(match.sportRef, match.categoryRef, match.tournamentRef, match.id);
        context.setMatchDataPalAvv(null);
    }

    let section = 'multi-bet';
    if (props.section != null && props.section !== 'live') {
        section = props.section;
    }

    useEffect(() => {
        initTables();
        initStatsUtils();
    }, []);

    return (
        <LiveContext.Provider value={context}>
            <CustomCols.Provider value={MAX_COLUMNS}>
                {function() {
                    switch(section) {
                        case 'live-suite':
                        case 'agenda':
                            return (
                            <AgendaStreamingContextProvider>
                                {isLiveTrackerEnabled() ?
                                    <LiveSuite openFromPath={props.openFromPath} openAgendaStreaming={section == 'agenda'} />
                                    :
                                    <MultiBet openAgendaStreaming={section == 'agenda'} />
                                }
                            </AgendaStreamingContextProvider>
                            );
                        case 'multi-bet':
                            return (
                                <AgendaStreamingContextProvider>
                                    <MultiBet />
                                </AgendaStreamingContextProvider>
                                );
                        case 'live-match':
                            return <LiveMatch />;
                        case 'multi-live':
                            return <MultiLive />;
                        case 'calendar':
                            return <Calendar />;
                        default:
                            return null;
                    }
                }()}
            </CustomCols.Provider>
        </LiveContext.Provider>
    )
}

export default Live;